import { render } from "./update-block-grade.vue?vue&type=template&id=2196bad4&scoped=true"
import script from "./update-block-grade.vue?vue&type=script&lang=js"
export * from "./update-block-grade.vue?vue&type=script&lang=js"

import "./update-block-grade.vue?vue&type=style&index=0&id=2196bad4&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2196bad4"],['__file',"src/components/applications/wagesetting/update/update-block-grade.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2196bad4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2196bad4', __exports__)) {
    api.reload('2196bad4', __exports__)
  }
  
  module.hot.accept("./update-block-grade.vue?vue&type=template&id=2196bad4&scoped=true", () => {
    api.rerender('2196bad4', render)
  })

}


export default __exports__